import { PERMISSIONS } from "@miplatform/constants";
import { IPermission } from "@miplatform/types";

export const preFilterModulePermissions = (
  permissions: IPermission[]
): IPermission[] => {
  return permissions.filter(
    (permission: IPermission) =>
      ![
        PERMISSIONS.MI_DISPATCH.ACCESS,
        PERMISSIONS.MI_SCHEDULING.ACCESS,
        PERMISSIONS.MI_ACCOUNTING.ACCESS,
        PERMISSIONS.MI_ESTIMATING.ACCESS,
        PERMISSIONS.MI_INSPECTIONS.ACCESS,
        PERMISSIONS.MIBUILD_MOBILE.ACCESS,
        PERMISSIONS.SYSTEM_ADMINISTRATION.ADMINISTRATION,
      ].includes(permission.name)
  );
};
